import { newReconGetServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchCities() {
  const url = `${NEW_BASE_URL}/v1/city/allCities`;
  return newReconGetServiceAPI(url);
}

export function fetchDataSyncStatus() {
  const url = `${NEW_BASE_URL}/v1/dataSync/dataSyncProgress`;
  return newReconGetServiceAPI(url);
}
